import { Component, Injectable, OnInit, ViewChild } from '@angular/core';
import { MatDatepickerInputEvent, MatDatepickerModule } from '@angular/material/datepicker';
import { ActivatedRoute } from '@angular/router';
import { MatPaginator, MatPaginatorIntl } from '@angular/material/paginator';
import { Subject } from 'rxjs';
import { MatTableDataSource } from '@angular/material/table';
import { Boletin } from '../../../shared/entities/Boletin';
import { VisualizadorService } from '../../../shared/service/visualizador.service';
import { DateAdapter, MAT_DATE_FORMATS, MatNativeDateModule } from '@angular/material/core';
import { PICK_FORMATS, PickDateAdapter } from '../../../shared/utilities/pick-date-adapter';
import { MenuAlternoComponent } from '../../public/menu-alterno/menu-alterno.component';
import { HeaderComponent } from '../../../shared/header/header.component';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatTableModule } from '@angular/material/table';
import { CommonModule } from '@angular/common';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatInputModule } from '@angular/material/input';


@Injectable()
export class MyCustomPaginatorIntl implements MatPaginatorIntl {
  changes = new Subject<void>();

  // For internationalization, the `$localize` function from
  // the `@angular/localize` package can be used.
  firstPageLabel = 'Primera página';
  itemsPerPageLabel = 'Elementos por página';
  lastPageLabel = 'Última página';

  // You can set labels to an arbitrary string too, or dynamically compute
  // it through other third-party internationalization libraries.
  nextPageLabel = 'Página anterior';
  previousPageLabel = 'Página siguiente';

  getRangeLabel(page: number, pageSize: number, length: number): string {
    if (length === 0) {
      return 'Página 1 de 1';
    }
    page++;
    const amountPages = Math.ceil(length / pageSize);
    return 'Página ' + page + ' de ' + amountPages;
  }
}

const today = new Date();
const month = today.getMonth();
const year = today.getFullYear();

@Component({
  selector: 'app-detalle-boletin',
  templateUrl: './detalle-boletin.component.html',
  styleUrls: ['./detalle-boletin.component.css'],
  providers: [
    { provide: DateAdapter, useClass: PickDateAdapter },
    { provide: MAT_DATE_FORMATS, useValue: PICK_FORMATS },
    { provide: MatPaginatorIntl, useClass: MyCustomPaginatorIntl }],
  standalone: true,
  imports: [CommonModule, HeaderComponent, MenuAlternoComponent, FormsModule, MatFormFieldModule, MatInputModule, MatDatepickerModule, MatTableModule, MatPaginatorModule, MatNativeDateModule, ReactiveFormsModule]
})
export class DetalleBoletinComponent implements OnInit {

  constructor(private service: VisualizadorService, private route: ActivatedRoute) { }


  readonly rangoFechas = new FormGroup({
    start: new FormControl(new Date(year, month, 13)),
    end: new FormControl(new Date(year, month, 16)),
  });

  fechaInicial = new FormControl();
  fechaFinal = new FormControl();

  boletinParam: string = '';
  listaBoletines: Boletin[] = [];
  boletinTempPorTipo: { [key: string]: Boletin[] } = {};
  boletinPorTipo: { [key: string]: Boletin[] } = {};
  tiposBoletin: string[] = [
    'MERCADOS_FINANCIEROS',
    'DIARIO_MERCADO_FORWARD',
    'MERCADO_FORWARDS_PLAZOS_CANTIDAD_PESOS',
    'NOTA_MONETARIA',
    'BOLETIN_SALDOS_FLUJOS',
    'INFORME_ESTADISTICAS_MONETARIAS_CAMBIARIAS',
    'BOLETIN_DEUDA_PUBLICA',
    'INFORME_OPERACIONES_DERIVADOS',
    'INFORME_BALANZA_PAGOS',
    'RANKING_HISTORICO_ENCUESTA_MENSUAL_EXPECTATIVAS'
  ];
  titulos: { [key: string]: string } = {
    'MERCADOS_FINANCIEROS': 'Informe de mercados financieros',
    'DIARIO_MERCADO_FORWARD': 'Informe diario de mercado de forward',
    'MERCADO_FORWARDS_PLAZOS_CANTIDAD_PESOS': 'Informe de mercado de forwards plazos cantidad de pesos',
    'NOTA_MONETARIA': 'Informe de nota monetaria',
    'BOLETIN_SALDOS_FLUJOS': 'Boletín de saldos y flujos',
    'INFORME_ESTADISTICAS_MONETARIAS_CAMBIARIAS': 'Informe semanal de estadísticas monetarias y cambiarias',
    'BOLETIN_DEUDA_PUBLICA': 'Boletín sobre deuda pública',
    'INFORME_OPERACIONES_DERIVADOS': 'Informe mensual de operaciones de derivados',
    'INFORME_BALANZA_PAGOS': 'Informe de la Evolución de la Balanza de Pagos y de la Posición de Inversión Internacional',
    'RANKING_HISTORICO_ENCUESTA_MENSUAL_EXPECTATIVAS': 'Rankings históricos de la evaluación de pronósticos mensual y acumulado año de la Encuesta mensual de expectativas de analistas económicos (EME)'
  };
  cabeceras: { [key: string]: string } = {
    'MERCADOS_FINANCIEROS': 'Semana',
    'DIARIO_MERCADO_FORWARD': 'Fecha del informe (dd/mm/aaaa)',
    'MERCADO_FORWARDS_PLAZOS_CANTIDAD_PESOS': 'Fecha del informe (dd/mm/aaaa)',
    'NOTA_MONETARIA': 'Documento',
    'INFORME_ESTADISTICAS_MONETARIAS_CAMBIARIAS': 'Datos históricos',
    'BOLETIN_DEUDA_PUBLICA': 'Trimestre',
    'INFORME_OPERACIONES_DERIVADOS': 'Mes',
    'INFORME_BALANZA_PAGOS': 'Documento',
    'BOLETIN_SALDOS_FLUJOS': 'Tipo informe',
    'RANKING_HISTORICO_ENCUESTA_MENSUAL_EXPECTATIVAS': 'Documento'
  };
  cabecerasAdicionales: { [key: string]: string } = {
    'INFORME_ESTADISTICAS_MONETARIAS_CAMBIARIAS': 'Información adicional'
  };
  picker: any;
  rangoFechasTope: { [key: string]: { [key: string]: Date } } = {};
  ready: boolean = false;
  fromDate: Date = new Date();
  toDate: Date = new Date();
  //displayedColumns: string[] = ['fecha', 'boletin'];
  displayedColumns: { [key: string]: string[] } = {
    'MERCADOS_FINANCIEROS': ['fecha', 'boletin'],
    'DIARIO_MERCADO_FORWARD': ['boletin'],
    'MERCADO_FORWARDS_PLAZOS_CANTIDAD_PESOS': ['boletin'],
    'NOTA_MONETARIA': ['fecha', 'boletin'],
    'INFORME_ESTADISTICAS_MONETARIAS_CAMBIARIAS': ['fecha', 'boletin', 'adicional'],
    'BOLETIN_DEUDA_PUBLICA': ['fecha', 'boletin'],
    'INFORME_OPERACIONES_DERIVADOS': ['fecha', 'boletin'],
    'INFORME_BALANZA_PAGOS': ['fecha', 'boletin'],
    'BOLETIN_SALDOS_FLUJOS': ['fecha', 'boletin'],
    'RANKING_HISTORICO_ENCUESTA_MENSUAL_EXPECTATIVAS': ['fecha', 'boletin']
  };
  @ViewChild(MatPaginator) paginator: MatPaginator | undefined;
  dataSource: MatTableDataSource<Boletin> = new MatTableDataSource<Boletin>;

  tituloColumnaFecha = 'Fecha del informe (dd/mm/aaaa)';

  ngOnInit(): void {
    this.ready = false;
    this.route.queryParams.subscribe({
      next: param => {
        this.boletinParam = param['boletin'];
        if (param['encuesta']) {
          this.boletinParam = param['encuesta'];
        } else if (param['boletin'] && param['boletin'] === 'MERCADOS_FINANCIEROS') {
          this.tituloColumnaFecha = 'Fecha de publicación (dd/mm/aaaa)';
        }

      }
    });
    this.service.consultaBoletin().subscribe({
      next: response => {
        this.listaBoletines = response;
        for (let tipoBoletin of this.tiposBoletin) {
          this.rangoFechasTope[tipoBoletin] = {};
          //if(this.listaBoletines){
          this.boletinPorTipo[tipoBoletin] = this.listaBoletines.filter(x => x.tipoBoletin === tipoBoletin);
          //}
          this.boletinPorTipo[tipoBoletin].map(boletin => { boletin.fechaBoletin = new Date(boletin.fechaBoletin) });
          this.boletinTempPorTipo[tipoBoletin] = this.boletinPorTipo[tipoBoletin];
          //if (this.boletinPorTipo[tipoBoletin][0] != undefined) {
          this.rangoFechasTope[tipoBoletin]['max'] = this.boletinPorTipo[tipoBoletin][0].fechaBoletin;
          //}
          //if (this.boletinPorTipo[tipoBoletin][this.boletinPorTipo[tipoBoletin].length - 1] != undefined) {
          this.rangoFechasTope[tipoBoletin]['min'] = this.boletinPorTipo[tipoBoletin][this.boletinPorTipo[tipoBoletin].length - 1].fechaBoletin;
          //}
        }
        this.dataSource = new MatTableDataSource<Boletin>(this.boletinPorTipo[this.boletinParam]);
        if (this.paginator)
          this.dataSource.paginator = this.paginator;
        this.ready = true;
        if (this.rangoFechasTope[this.boletinParam]) {
          this.fromDate = this.rangoFechasTope[this.boletinParam]['min'];
          this.toDate = this.rangoFechasTope[this.boletinParam]['max'];
        }
      }
    });
  }

  setDates(condition: string, event: MatDatepickerInputEvent<Date>) {
    if (event.value != null) {
      if (condition === 'from') {
        if (event.value)
          this.fromDate = event.value;
      } else if (condition === 'to') {
        if (event.value)
          this.toDate = event.value;
      }
      this.dataSource.data = this.boletinTempPorTipo[this.boletinParam]
        .filter(boletin => new Date(boletin.fechaBoletin.getTime() + 18000000) >= this.fromDate && new Date(boletin.fechaBoletin.getTime() + 18000000) <= this.toDate);
    }
  }

}
